import { DateSchema } from 'joi'
import {
  addDays,
  addMonths,
  endOfMonth,
  setHours,
  setMinutes,
  setSeconds,
  min,
} from 'date-fns'
import { parseDate } from '@ads/front-core/utils'
import Joi from '@ads/front-core/utils/joi'
import { lng } from '@ads/front-core/locales'

export const campaignMaxDateByDays = (days: number) => (
  startDate?: Date | string,
): {
  maxDate: Date
  defaultDate?: Date
  joi: DateSchema<Date>
} => {
  const joi = Joi.date()
    .when('dateStart', {
      is: Joi.date().exist(),
      then: Joi.date()
        .iso()
        .min(Joi.ref('dateStart'))
        .message(
          lng('errors:dateMin').replace('{#limit}', lng('calendar:startDate')),
        )
        .max(
          Joi.ref('dateStart', {
            adjust: val => addDays(val, days),
          }),
        )
        .message(
          lng('errors:campaignCanNotLastMoreThanXDays', {
            arg: days,
          }),
        ),
      otherwise: Joi.date().iso().min(new Date()),
    })
    .required()

  const baseDate = startDate ? parseDate(startDate) : new Date()
  const maxDate = addDays(baseDate, days)
  const endOfNextMonth = setSeconds(
    setMinutes(setHours(endOfMonth(addMonths(baseDate, 1)), 23), 59),
    0,
  )
  const defaultDate = min([endOfNextMonth, maxDate])

  return {
    maxDate,
    defaultDate,
    joi,
  }
}
